export default __webpack_public_path__ + "static/160-b0b2253654dbeba301394e90f77c7b95.gif";